import { useCart } from "../../context/CartContext";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { toast } from "react-toastify";

export default function CartPage() {
  const { cartItems, updateQty, removeFromCart, clearCart, total } = useCart();

  useEffect(() => {
    console.log("🧾 CartPage - cartItems from context:", cartItems);
  }, [cartItems]);

  const handleQuantityChange = (item, newQty) => {
    const qty = parseInt(newQty, 10);
    if (isNaN(qty) || qty < 1) {
      toast.warning("Quantity must be at least 1");
      return;
    }
    updateQty(item.key, qty);
  };

  const handleRemove = (item) => {
    removeFromCart(item.key);
    toast.info("Removed from cart");
  };

  const handleClearCart = () => {
    if (window.confirm("Clear entire cart?")) {
      clearCart();
      toast.success("Cart cleared");
    }
  };

  return (
    <div className="max-w-4xl font-libreFranklin mx-auto py-12 px-4 mt-24">
      <h2 className="text-3xl font-bold mb-6">Your Cart</h2>

      {cartItems.length === 0 ? (
        <div className="text-center text-gray-500 py-12">
          <svg
            className="w-20 h-20 mx-auto mb-4 text-gray-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
          <p className="text-xl mb-4">Your cart is empty.</p>
          <Link
            to="/category/women"
            className="inline-block bg-black text-white px-6 py-3 rounded hover:bg-gray-800 transition-colors"
          >
            Continue Shopping
          </Link>
        </div>
      ) : (
        <>
          {/* Cart Items */}
          <div className="space-y-4 mb-8">
            {cartItems.map((item) => (
              <div
                key={item.key}
                className="flex gap-4 border rounded-lg p-4 hover:shadow-md transition-shadow bg-white"
              >
                {/* Image */}
                <div className="flex-shrink-0">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-24 h-24 object-cover rounded"
                  />
                </div>

                {/* Details */}
                <div className="flex-1">
                  <h4 className="font-semibold text-lg mb-2">{item.title}</h4>

                  {/* Attributes */}
                  <div className="text-sm text-gray-600 space-y-1 mb-3">
                    {item.color && (
                      <p>
                        <span className="font-medium">Color:</span> {item.color}
                      </p>
                    )}
                    {item.size && (
                      <p>
                        <span className="font-medium">Size:</span> {item.size}
                      </p>
                    )}
                    {item.material && (
                      <p>
                        <span className="font-medium">Material:</span>{" "}
                        {item.material}
                      </p>
                    )}
                  </div>

                  {/* Price */}
                  <p className="font-semibold text-lg">
                    ${Number(item.price).toFixed(2)}
                  </p>
                </div>

                {/* Quantity & Actions */}
                <div className="flex flex-col justify-between items-end">
                  {/* Quantity */}
                  <div className="flex items-center gap-2 mb-2">
                    <label className="text-sm text-gray-600">Qty:</label>
                    <input
                      type="number"
                      min="1"
                      value={item.quantity}
                      onChange={(e) => handleQuantityChange(item, e.target.value)}
                      className="w-16 px-2 py-1 border rounded text-center"
                    />
                  </div>

                  {/* Subtotal */}
                  <p className="text-sm text-gray-600 mb-2">
                    Subtotal: ${(Number(item.price) * item.quantity).toFixed(2)}
                  </p>

                  {/* Remove Button */}
                  <button
                    className="text-red-500 hover:text-red-700 text-sm underline"
                    onClick={() => handleRemove(item)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Summary */}
          <div className="border-t pt-6">
            <div className="flex justify-between items-center mb-6">
              <div>
                <p className="text-gray-600 mb-1">
                  {cartItems.length} item{cartItems.length > 1 ? "s" : ""} in cart
                </p>
                <p className="text-3xl font-bold">
                  ${total.toFixed(2)}
                </p>
              </div>

              <div className="flex gap-3">
                <button
                  className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50 transition-colors"
                  onClick={handleClearCart}
                >
                  Clear Cart
                </button>
                <Link
                  to="/checkout"
                  className="px-6 py-2 bg-black text-white rounded hover:bg-gray-800 transition-colors"
                >
                  Proceed to Checkout
                </Link>
              </div>
            </div>

            {/* Continue Shopping */}
            <Link
              to="/category/women"
              className="text-sm text-gray-600 hover:text-black underline"
            >
              ← Continue Shopping
            </Link>
          </div>
        </>
      )}
    </div>
  );
}